// Libs
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

// Components
import App from '@app/App';
import store from '@app/store/store';

// Locales
import '@app/i18n';

// Service worker
import * as serviceWorkerRegistration from '@app/serviceWorkerRegistration';
import { initUpdateListeners, notifyUpdate, watchForUpdates } from '@app/swUpdate';

// Font tự chứa (Inter + Noto Serif, subset latin + vietnamese)
import '@app/fonts';

// Bắt beforeinstallprompt TOÀN CỤC ngay khi khởi động (trước render) — không lỡ sự kiện
// bắn ở màn login rồi chuyển SPA sang /owner.
import '@app/installPrompt';

// Web analytics
import reportWebVitals from '@app/reportWebVitals';

import { loadConfig } from './config';
// import { createAxiosInstance } from './apis/axiosClient';

// Nhãn bản build (tuỳ chọn, `REACT_APP_BUILD_TAG` lúc build) → <html data-build>. Dùng để
// nhận diện bản đang chạy (E2E kiểm cập nhật SW, hỗ trợ khách). Không đặt = không gắn.
if (process.env.REACT_APP_BUILD_TAG) {
  document.documentElement.dataset.build = process.env.REACT_APP_BUILD_TAG;
}

loadConfig().then(() => {
  // createAxiosInstance();
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
});

// Service worker (Round 15): BẬT ở production — Chrome Android chỉ bắn beforeinstallprompt
// (nút cài 1 chạm) khi có SW đã đăng ký kèm fetch handler. Đường thoát "kẹt bản cũ":
// bản mới cài xong → thanh UpdatePrompt hỏi người dùng → SKIP_WAITING → reload (swUpdate.js).
// Dev (npm start) vẫn unregister để không cache bundle đang sửa.
if (process.env.NODE_ENV === 'production') {
  initUpdateListeners();
  serviceWorkerRegistration.register({
    onUpdate: notifyUpdate,
    onRegistered: watchForUpdates,
  });
} else {
  serviceWorkerRegistration.unregister();
}

reportWebVitals();
